import React from 'react';
import PropTypes from 'prop-types';

import ContactReminders from 'components/Reminders/ContactReminders';
import RemindersErrorBoundary from 'components/Reminders/RemindersErrorBoundary';

const Summary = ({
  contactId
}) => (
  <div>
    <RemindersErrorBoundary>
      <ContactReminders contactId={contactId} />
    </RemindersErrorBoundary>
  </div>
);

Summary.defaultProps = {
  contactId: ''
};

Summary.propTypes = {
  contactId: PropTypes.string
};

export default Summary;
